import config from '../../constants/unread-chatroom-count-config';
import { hashUnreadFilter } from './reducer.unread-chatroom-count';
import _isEmpty from 'lodash/isEmpty';
export var isChatroomUnread = function (chatroom) {
    var lastMessage = chatroom.lastMessage, _a = chatroom.lastReadMessageSequence, lastReadMessageSequence = _a === void 0 ? 0 : _a;
    if (!lastMessage) {
        return false;
    }
    return lastReadMessageSequence < lastMessage.sequence;
};
export var getUnreadChatroomCount = function (state, filter) {
    var filtered = state === null || state === void 0 ? void 0 : state.unreadChatroomCount.byFilter[hashUnreadFilter(filter)];
    if (!filtered || _isEmpty(filtered)) {
        return null;
    }
    if ('resyncCountdown' in filtered) {
        return {
            count: config.maxUnreadsCount,
            overflow: true,
        };
    }
    var chatrooms = filtered.chatrooms;
    return {
        count: Math.min(config.maxUnreadsCount, Object.keys(chatrooms).length),
        overflow: Object.keys(chatrooms).length > config.maxUnreadsCount,
    };
};
